// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Ds5k","selected":"Chip_selected__2F37H"};